import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Dolgcas?",
  "description": "",
  "published": "2007-01-25T00:00:00.000Z",
  "redirect_from": ["/blog/dolgcas/swizec/304"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ce vam kdaj postane zelo in prevec dolgcas, postanite`}<a parentName="p" {...{
        "href": "http://www.beseechfanclub.com/bored/"
      }}>{` zival`}</a>{`, da se pomirite.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      